import { Form, Input, Switch, Button, Card, Space } from 'antd'
import type { User } from '@/types/user'

export interface UserFormValues {
  email: string
  first_name: string
  last_name: string
  nickname?: string
  receiver: boolean
  active?: boolean
}

interface UserFormProps {
  initialValues?: Partial<User>
  onSubmit: (values: UserFormValues) => void
  onCancel: () => void
  isLoading?: boolean
  isEdit?: boolean
}

export const UserForm: React.FC<UserFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  isLoading = false,
  isEdit = false,
}) => {
  const [form] = Form.useForm()

  const handleSubmit = (values: UserFormValues) => {
    onSubmit(values)
  }

  return (
    <Card>
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          receiver: false,
          active: true,
          ...initialValues,
        }}
        onFinish={handleSubmit}
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Please input email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input size="large" placeholder="user@example.com" />
        </Form.Item>

        <Form.Item
          label="First Name"
          name="first_name"
          rules={[{ required: true, message: 'Please input first name!' }]}
        >
          <Input size="large" placeholder="John" />
        </Form.Item>

        <Form.Item
          label="Last Name"
          name="last_name"
          rules={[{ required: true, message: 'Please input last name!' }]}
        >
          <Input size="large" placeholder="Doe" />
        </Form.Item>

        <Form.Item label="Nickname" name="nickname">
          <Input size="large" placeholder="Optional nickname" />
        </Form.Item>

        <Form.Item label="Receiver" name="receiver" valuePropName="checked">
          <Switch />
        </Form.Item>

        {isEdit && (
          <Form.Item label="Active" name="active" valuePropName="checked">
            <Switch />
          </Form.Item>
        )}

        <Form.Item>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={isLoading}
              disabled={isLoading}
            >
              {isEdit ? 'Update User' : 'Create User'}
            </Button>
            <Button size="large" onClick={onCancel} disabled={isLoading}>
              Cancel
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Card>
  )
}
